"use client";
import Image from "next/image";
import { Breadcrumb } from "antd";

export default function Banner() {
  return (
    <div className="relative w-full h-[300px] flex items-center overflow-hidden">
      {/* Background image */}
      <Image
        src="/images/about-us-banner.png"
        fill
        className="object-cover"
        priority
      />

      {/* Overlay gradient */}
      <div className="absolute inset-0 bg-gradient-to-r from-black via-black/80 to-transparent"></div>

      {/* Content */}
      <div className="relative z-10 text-white px-6 md:px-16">
        <h1 className="text-4xl md:text-4xl font-bold mb-1">About Us</h1>
        <div className="flex items-center gap-2 mt-2">
          <a href="/" className="text-white text-sm inline-flex items-center">
            Home
          </a>
          <span className="text-white font-semibold">|</span>
          <span className="text-white text-sm inline-flex items-center">About Us</span>
        </div>
      </div>
    </div>
  );
}
